import React from "react"
import {
  BrandLetterGroups,
  BrandLetterItem,
} from "../../../../contents/brands/types"
import Typography from "../../../../ui/atoms/Typography"
import { CustomCol, CustomRow } from "../../../../ui/spacings"
import { scrollToElement } from "../../../../ui/utilities/scrolling"
import { buildPanelItemId } from "../BrandsPanel"
import classes from "./BrandsSidebar.module.css"

interface Props {
  brands: BrandLetterGroups
}

const BrandsSidebar = ({ brands }: Props) => {
  const handleClick = (item: BrandLetterItem) => {
    scrollToElement(buildPanelItemId(item.letter), 30)
  }

  return (
    <div>
      <Typography variant="h5" weight="normal" className={classes.title}>
        A - Z
      </Typography>
      <CustomRow className="mt-6">
        {brands.map((x) => (
          <CustomCol key={x.letter} xs={3} className="mb-2">
            <Typography
              variant="subtitle2"
              textClassName={classes.letter}
              onClick={() => handleClick(x)}
            >
              {x.letter.toUpperCase()}
            </Typography>
          </CustomCol>
        ))}
      </CustomRow>
    </div>
  )
}

export default BrandsSidebar
